var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg31(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 300,
    height: 300,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-0.2881232366499863"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 62.143L95.5 0L191 62.143V195H0V62.143Z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 62.143L95.5 0L191 62.143V195H0V62.143Z",
    fill: "rgba(191, 191, 191, 100)",
    transform: "scale(1.5706806282722514, 1.5384615384615385)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 62.143L95.5 0L191 62.143V195H0V62.143Z",
    fill: "none",
    stroke: "#0c0c0c",
    strokeWidth: 0,
    clipPath: "url(#clip-0.2881232366499863)",
    transform: "scale(1.5706806282722514, 1.5384615384615385)",
    strokeDasharray: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg31);
export default __webpack_public_path__ + "static/media/31.c110796ffa50d3e6c03177b964998fdd.svg";
export { ForwardRef as ReactComponent };